/**
 * Чем сужают выборку задач: исполнитель, автор, тип, приоритет и текстовый
 * поиск.
 *
 * Отбор общий у доски и списка — это один и тот же фильтр-бар в панели, и
 * человек, переключивший вид, ждёт, что отобранное останется отобранным.
 *
 * Фильтрует сервер, а не экран: и в колонку доски, и на страницу списка
 * приезжает лишь часть задач, и отбор на клиенте показывал бы «две задачи
 * Михаила» там, где их десять.
 */
import type { V1IssueType, V1Priority } from '@/api/clients/tracker-issue'

export interface IssueFilters {
  assigneeIds: string[]
  /** Авторы — те, кто задачу завёл; вопрос отдельный от «что на мне» */
  reporterIds: string[]
  types: V1IssueType[]
  priorities: V1Priority[]
  /**
   * Колонки доски — чип «Статус» списка (DEV-2042). Доска этот фильтр не
   * применяет: колонки — это её оси, и она показывает чип «часть отбора не
   * действует» вместо молчаливого игнора.
   */
  columnIds: string[]
  /** Полнотекстовый запрос по названию и описанию */
  search: string
}

export const emptyFilters = (): IssueFilters => ({
  assigneeIds: [],
  reporterIds: [],
  types: [],
  priorities: [],
  columnIds: [],
  search: '',
})

export const hasAnyFilter = (filters: IssueFilters): boolean =>
  filters.assigneeIds.length > 0 ||
  filters.reporterIds.length > 0 ||
  filters.types.length > 0 ||
  filters.priorities.length > 0 ||
  filters.columnIds.length > 0 ||
  filters.search.trim().length > 0

/** Пустой отбор — это отсутствие параметра: `?filter.types=` сервер не поймёт */
export const orNothing = <T>(values: T[]): T[] | undefined => (values.length ? values : undefined)
